var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section-data-wrapper",class:{'is-loading': _vm.loading}},[(_vm.loading)?_c('p',[_vm._v("Loading...")]):_vm._t("default",null,{"title":_vm.title,"content":_vm.content,"featuredImageVersions":_vm.featuredImageVersions})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }